/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

interface IArgs {
  options: string[];
  selected: string;
  name: string;
  disabled?: boolean;
  onChange: (channel: string) => void;
}

interface ChannelRadiosSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

const UiMessagesChannelRadiosComponent = templateOnly<ChannelRadiosSignature>();

export default UiMessagesChannelRadiosComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Messages::ChannelRadios': typeof UiMessagesChannelRadiosComponent;
  }
}
